// src/components/Signup/SignupProgress.jsx

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const SignupProgress = ({ currentStep, totalSteps = 3 }) => {
  const { t } = useTranslation();
  
  const stepLabels = [
    t('signup.personalDetails.header'),
    t('signup.password.header'),
    t('signup.success.header')
  ];

  return (
    <div className="w-full mb-8">
      <div className="flex items-center justify-center">
        {Array.from({ length: totalSteps }, (_, index) => {
          const stepNumber = index + 1;
          const isActive = stepNumber === currentStep;
          const isCompleted = stepNumber < currentStep;

          return (
            <div key={stepNumber} className="flex items-center">
              {/* Step Circle */}
              <div
                className={`
                  flex items-center justify-center size-8 rounded-full text-sm font-semibold
                  ${isActive 
                    ? 'bg-blue-600 text-white' 
                    : isCompleted 
                      ? 'bg-green-600 text-white' 
                      : 'bg-gray-300 text-gray-600'
                  }
                `}
              >
                {isCompleted ? '✓' : stepNumber}
              </div>

              {/* Step Label */}
              <div className="ml-2 mr-4 hidden md:block">
                <span
                  className={`
                    text-xs font-medium
                    ${isActive 
                      ? 'text-blue-600' 
                      : isCompleted 
                        ? 'text-green-600' 
                        : 'text-gray-500'
                    }
                  `}
                >
                  {stepLabels[index]}
                </span>
              </div>

              {/* Connector Line */}
              {stepNumber < totalSteps && (
                <div
                  className={`
                    h-0.5 w-8 md:w-16
                    ${isCompleted ? 'bg-green-600' : 'bg-gray-300'}
                  `}
                />
              )}
            </div>
          );
        })}
      </div>

      {/* Mobile Step Label */}
      <div className="md:hidden mt-3 text-center">
        <span className="text-sm font-medium text-blue-600">
          {stepLabels[currentStep - 1]}
        </span>
      </div>

      {/* Progress Bar */}
      <div className="mt-4 w-full bg-gray-200 rounded-full h-2">
        <div
          className="bg-blue-600 h-2 rounded-full transition-all duration-300"
          style={{ width: `${(currentStep / totalSteps) * 100}%` }}
        />
      </div>
    </div>
  );
};

SignupProgress.propTypes = {
  currentStep: PropTypes.number.isRequired,
  totalSteps: PropTypes.number
};

export default SignupProgress;